export const navigateCurrentWindow = (url) => window.location.assign(url)
